var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"middle"},[_vm._v(" 宏达运智慧监测平台 ")])])])
}]

export { render, staticRenderFns }